import { Redirect, Route, Switch } from 'quartz-routing/react-router';
import Application from '../containers/Application';
import Home from '../containers/Home';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PATHS = {
  ACCOUNTS: '/myaccounts',
  ACCOUNTS_BETA: '/myaccounts-beta'
};
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    exact: true,
    path: PATHS.ACCOUNTS_BETA,
    children: /*#__PURE__*/_jsx(Redirect, {
      to: PATHS.ACCOUNTS
    })
  }), /*#__PURE__*/_jsx(Route, {
    path: PATHS.ACCOUNTS,
    children: /*#__PURE__*/_jsx(Application, {
      children: /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: PATHS.ACCOUNTS,
        component: Home
      })
    })
  })]
});